import { c as _c } from "react/compiler-runtime";
import type { VaultFormData } from '@onefootprint/core';
import type { CustomRequirementNumberFormat, Iso4217CurrencyCode, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import type { Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type NumberInputProps = {
  name: string;
  label: string;
  requiredRules: {
    required?: string;
  };
  format?: CustomRequirementNumberFormat;
  min?: number;
  max?: number;
  placeholder?: string;
  locale?: Locale;
};
export const NumberInput = t0 => {
  const $ = _c(29);
  const {
    name,
    label,
    requiredRules,
    format,
    min,
    max,
    placeholder,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData.pages.customDataForm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const isCurrency = format?.formatKind === "currency";
  let t2;
  if ($[1] !== max || $[2] !== min || $[3] !== t) {
    t2 = () => {
      if (typeof max === "number" && typeof min === "number") {
        return t(_temp, {
          min,
          max
        });
      }
      if (typeof max === "number") {
        return t(_temp2, {
          max
        });
      }
      if (typeof min === "number") {
        return t(_temp3, {
          min
        });
      }
    };
    $[1] = max;
    $[2] = min;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getHint = t2;
  const t3 = name as Path<VaultFormData>;
  let t4;
  if ($[5] !== getHint) {
    t4 = getHint();
    $[5] = getHint;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== format || $[8] !== isCurrency) {
    t5 = isCurrency ? getCurrencySymbol(format.code) : undefined;
    $[7] = format;
    $[8] = isCurrency;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isCurrency ? 2 : undefined;
  let t7;
  if ($[10] !== min || $[11] !== t) {
    t7 = min !== undefined ? {
      value: min,
      message: t(_temp4, {
        min
      })
    } : undefined;
    $[10] = min;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== max || $[14] !== t) {
    t8 = max !== undefined ? {
      value: max,
      message: t(_temp5, {
        max
      })
    } : undefined;
    $[13] = max;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== requiredRules || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      ...requiredRules,
      min: t7,
      max: t8
    };
    $[16] = requiredRules;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== label || $[21] !== locale || $[22] !== placeholder || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t9) {
    t10 = <Form.Number name={t3} label={label} placeholder={placeholder} hint={t4} locale={locale} addon={t5} decimalPlaces={t6} rules={t9} />;
    $[20] = label;
    $[21] = locale;
    $[22] = placeholder;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
const getCurrencySymbol = (code: Iso4217CurrencyCode): string => {
  if (code === 'usd') {
    return '$';
  }
  return code satisfies never;
};
function _temp($) {
  return $.number.labelMinMax;
}
function _temp2($_0) {
  return $_0.number.labelMax;
}
function _temp3($_1) {
  return $_1.number.labelMin;
}
function _temp4($_2) {
  return $_2.number.min;
}
function _temp5($_3) {
  return $_3.number.max;
}